import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaBolt, FaCheck } from 'react-icons/fa';
import zeduttLogo from '../../assets/zedutt-logo.jpeg';
import './Products.css';

const points = [
  'Visual drag-and-drop pipeline with lead scoring',
  'Email automation, drip sequences, and a WhatsApp inbox',
  'AI lead assist and analytics powered by Claude',
  'Web-to-lead capture, meetings, and calendar invites',
  'Multi-tenant with a read-only portal for each client',
  'Stripe subscription billing built in',
];

const Products = () => {
  return (
    <div className="products-page">
      {/* ── HERO ── */}
      <section className="prod-hero">
        <div className="container">
          <motion.p
            className="sec-overline"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            Our Products
          </motion.p>
          <motion.h1
            className="prod-page-title"
            initial={{ opacity: 0, y: 22, filter: 'blur(6px)' }}
            animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.08 }}
          >
            Software we build<br />and run ourselves<span className="accent-dot">.</span>
          </motion.h1>
          <motion.p
            className="prod-page-sub"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.18 }}
          >
            Beyond client work, we ship our own products — built on everything we've
            learned delivering for businesses across India.
          </motion.p>
        </div>
      </section>

      {/* ── ZEDUTT ── */}
      <section className="prod-list" id="zedutt">
        <div className="container">
          <motion.article
            className="prod-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            {/* Zedutt logo — links to the live product */}
            <a
              className="prod-logo-tile"
              href="https://zedutt.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Zedutt"
            >
              <img src={zeduttLogo} alt="Zedutt" className="zedutt-logo-img" />
            </a>

            <div className="prod-info">
              <span className="prod-badge"><FaBolt /> Multi-tenant CRM</span>
              <h2 className="prod-name">Zedutt</h2>
              <p className="prod-tagline">Make a zedutt to your leads.</p>
              <p className="prod-desc">
                A CRM built for marketing agencies — track leads, manage client accounts
                and campaigns, and give each client a read-only portal into their own
                pipeline. Multi-tenant from the ground up, with subscription billing baked in.
              </p>
              <ul className="prod-points">
                {points.map((p) => (
                  <li key={p}><FaCheck /> {p}</li>
                ))}
              </ul>
              <div className="prod-actions">
                <a href="https://zedutt.com" target="_blank" rel="noopener noreferrer" className="btn-primary">
                  Visit Zedutt <FaArrowRight className="btn-icon" />
                </a>
                <a href="mailto:info@abidottsolutions.com" className="btn-outline">
                  Request a demo
                </a>
              </div>
            </div>
          </motion.article>
        </div>
      </section>
    </div>
  );
};

export default Products;
